module.exports = __webpack_public_path__ + "img/quest_icon_0064_lock.fa53a961.png";